import { render, staticRenderFns } from "./StartupCosts.vue?vue&type=template&id=6a6ec078"
import script from "./StartupCosts.vue?vue&type=script&lang=js"
export * from "./StartupCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports